import Header from '~/Components/Header/Header';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  Form,
  Button,
  Card,
  Row,
  Col,
  InputGroup,
  Modal,
  Tabs,
  Tab,
  Table as BsTable,
  Badge,
  Collapse,
  Spinner,
  Alert,
} from 'react-bootstrap';
import { Formik } from 'formik';
import Select from 'react-select';
import DateMask from '~/Components/DateMask';
import MaskedInput from 'react-text-mask';
import * as constants from '~/constant';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import {
  FaSearch,
  FaFileUpload,
  FaWindowClose,
  FaInfoCircle,
  FaHistory,
  FaChevronDown,
  FaUser,
  FaUsers,
  FaUserFriends,
  FaEnvelope,
  FaFileAlt,
  FaCheck,
  FaTimes,
  FaFilePdf,
  FaTrash,
  FaPaperPlane,
  FaEye,
  FaCog,
  FaLock,
  FaFileSignature,
  FaSortUp,
  FaSortDown,
} from 'react-icons/fa';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';
import { format } from '~/Utils/Helpers';
import AuthStorage from '~/Utils/AuthStorage';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DocumentoDigitalEscritura from './DocumentoDigitalEscritura';
import DisplayDocumentosEscritura from '~/Components/DocumentoDigital/DisplayDocumentosEscritura';

const ETAPAS_OPTIONS = [
  { value: 1, label: 'Preencher Formulário' },
  { value: 2, label: 'Análise da Documentação' },
  { value: 3, label: 'Emissão e Envio da Autorização' },
  { value: 4, label: 'Documentos Disponibilizados' },
];

const SUBETAPAS_OPTIONS = [
  { value: 1, label: 'Em Andamento' },
  { value: 2, label: 'Aprovado' },
  { value: 3, label: 'Reprovado' },
  { value: 4, label: 'Documento Emitido' },
  { value: 5, label: 'Expirado' },
];

const TIPO_ENVIO_OPTIONS = [
  { value: 1, label: 'Físico' },
  { value: 2, label: 'Digital' },
];

// Mesma ordem do enum Setpar.Domain.PerfilComprador.
const PERFIL_CLIENTE_OPTIONS = [
  { value: 1, label: 'Construtor' },
  { value: 2, label: 'Morador' },
  { value: 3, label: 'Investidor' },
  { value: 4, label: 'Exterior' },
];

const getDescricaoTipoEnvio = tipoEnvio => {
  const found = TIPO_ENVIO_OPTIONS.find(t => t.value === tipoEnvio);
  return found ? found.label : '-';
};

const getDescricaoPerfilCliente = perfil => {
  if (perfil === null || perfil === undefined) return '-';
  const found = PERFIL_CLIENTE_OPTIONS.find(p => p.value === perfil);
  return found ? found.label : '-';
};

const getDescricaoEtapa = etapa => {
  const found = ETAPAS_OPTIONS.find(e => e.value === etapa);
  return found ? found.label : '-';
};

const getDescricaoStatus = status => {
  const found = SUBETAPAS_OPTIONS.find(s => s.value === status);
  return found ? found.label : '-';
};

const getEtapaStyle = etapa => {
  const styles = {
    1: {
      backgroundColor: 'transparent',
      color: '#0d6efd',
      border: '1px solid #0d6efd',
    },
    2: {
      backgroundColor: 'transparent',
      color: '#fd7e14',
      border: '1px solid #fd7e14',
    },
    3: {
      backgroundColor: 'transparent',
      color: '#6f42c1',
      border: '1px solid #6f42c1',
    },
    4: {
      backgroundColor: 'transparent',
      color: '#198754',
      border: '1px solid #198754',
    },
  };
  return (
    styles[etapa] || {
      backgroundColor: 'transparent',
      color: '#6c757d',
      border: '1px solid #6c757d',
    }
  );
};

const getStatusStyle = status => {
  const styles = {
    1: {
      backgroundColor: 'transparent',
      color: '#17a2b8',
      border: '1px solid #17a2b8',
    },
    2: {
      backgroundColor: 'transparent',
      color: '#28a745',
      border: '1px solid #28a745',
    },
    3: {
      backgroundColor: 'transparent',
      color: '#dc3545',
      border: '1px solid #dc3545',
    },
    4: {
      backgroundColor: 'transparent',
      color: '#6f42c1',
      border: '1px solid #6f42c1',
    },
    5: {
      backgroundColor: 'transparent',
      color: '#fd7e14',
      border: '1px solid #fd7e14',
    },
  };
  return (
    styles[status] || {
      backgroundColor: 'transparent',
      color: '#6c757d',
      border: '1px solid #6c757d',
    }
  );
};

const renderEtapaPill = etapa => {
  const label = getDescricaoEtapa(etapa);
  const style = getEtapaStyle(etapa);
  return (
    <Badge
      style={{
        ...style,
        fontSize: '0.75em',
        fontWeight: '600',
        padding: '3px 8px',
        borderRadius: '4px',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Badge>
  );
};

const renderStatusPill = status => {
  const label = getDescricaoStatus(status);
  const style = getStatusStyle(status);
  return (
    <Badge
      style={{
        ...style,
        fontSize: '0.75em',
        fontWeight: '600',
        padding: '3px 8px',
        borderRadius: '4px',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Badge>
  );
};

const isSolicitacaoFinalizada = item => {
  return item.etapa_atual === 4 && item.status_etapa === 4;
};

const isFluxoHerdeirosFinalizado = item => {
  return (
    item.tem_herdeiros === true &&
    item.etapa_atual === 2 &&
    item.status_etapa === 2
  );
};

const renderFinalizadoPill = () => (
  <Badge
    style={{
      backgroundColor: '#198754',
      color: '#fff',
      fontSize: '0.75em',
      fontWeight: '600',
      padding: '3px 8px',
      borderRadius: '4px',
      whiteSpace: 'nowrap',
    }}
  >
    Finalizado
  </Badge>
);

export default function SolicitacoesEscritura() {
  const temPermissao = AuthStorage.temCaracteristica(
    constants.caracteristicas.TelaAutoatendimentoEscritura
  );

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [solicitacoes, setSolicitacoes] = useState([]);
  const [lastFilters, setLastFilters] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    key: 'data',
    direction: 'desc',
  });
  const [showModalDetalhes, setShowModalDetalhes] = useState(false);
  const [itemSelecionado, setItemSelecionado] = useState(null);
  const [detalhesCliente, setDetalhesCliente] = useState(null);
  const [isLoadingDetalhes, setIsLoadingDetalhes] = useState(false);
  const [openCards, setOpenCards] = useState({
    dados: false,
    participantes: false,
    envio: false,
    documentacao: false,
    herdeiros: false,
  });
  const [documentoPreviewUrl, setDocumentoPreviewUrl] = useState(null);
  const [acaoSelecionada, setAcaoSelecionada] = useState(null);
  const [observacaoAcao, setObservacaoAcao] = useState('');
  const [enviarEmailCliente, setEnviarEmailCliente] = useState(true);
  const [isLoadingAcao, setIsLoadingAcao] = useState(false);
  const [camposReprovados, setCamposReprovados] = useState([]);

  const [showModalEnviarDoc, setShowModalEnviarDoc] = useState(false);
  const [itemEnviarDoc, setItemEnviarDoc] = useState(null);
  const [arquivoSelecionado, setArquivoSelecionado] = useState(null);
  const [arquivoPreview, setArquivoPreview] = useState(null);
  const [enviarEmailDocumento, setEnviarEmailDocumento] = useState(false);
  const [mensagemEmailDocumento, setMensagemEmailDocumento] = useState('');
  const [observacaoDocumento, setObservacaoDocumento] = useState('');
  const [isLoadingEnviarDoc, setIsLoadingEnviarDoc] = useState(false);
  const fileInputRef = useRef(null);

  const [showModalConfirmacaoEnvio, setShowModalConfirmacaoEnvio] = useState(
    false
  );

  const [showModalGerenciarStatus, setShowModalGerenciarStatus] = useState(
    false
  );
  const [itemGerenciarStatus, setItemGerenciarStatus] = useState(null);
  const [etapaSelecionadaStatus, setEtapaSelecionadaStatus] = useState(null);
  const [subStatusSelecionado, setSubStatusSelecionado] = useState(null);
  const [arquivoGerenciarStatus, setArquivoGerenciarStatus] = useState(null);
  const [
    arquivoGerenciarStatusPreview,
    setArquivoGerenciarStatusPreview,
  ] = useState(null);
  const [observacaoGerenciarStatus, setObservacaoGerenciarStatus] = useState(
    ''
  );
  const [enviarEmailGerenciarStatus, setEnviarEmailGerenciarStatus] = useState(
    true
  );
  const [
    mensagemEmailGerenciarStatus,
    setMensagemEmailGerenciarStatus,
  ] = useState('');
  const [isLoadingGerenciarStatus, setIsLoadingGerenciarStatus] = useState(
    false
  );
  const fileInputGerenciarStatusRef = useRef(null);

  const [showModalAvisoSemDocumento, setShowModalAvisoSemDocumento] = useState(
    false
  );

  const [showModalDocDigital, setShowModalDocDigital] = useState(false);
  const [itemDocDigital, setItemDocDigital] = useState(null);

  const [cidadesOpts, setCidadesOpts] = useState([]);

  const sortedSolicitacoes = React.useMemo(() => {
    if (!solicitacoes || solicitacoes.length === 0) return [];
    return [...solicitacoes].sort((a, b) => {
      var av = a[sortConfig.key];
      var bv = b[sortConfig.key];
      if (sortConfig.key === 'data') {
        var pa = new Date(av);
        var pb = new Date(bv);
        return sortConfig.direction === 'asc' ? pa - pb : pb - pa;
      }
      var na = parseFloat(av);
      var nb = parseFloat(bv);
      if (!isNaN(na) && !isNaN(nb))
        return sortConfig.direction === 'asc' ? na - nb : nb - na;
      var sa = String(av || '').toLowerCase();
      var sb = String(bv || '').toLowerCase();
      if (sa < sb) return sortConfig.direction === 'asc' ? -1 : 1;
      if (sa > sb) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  }, [solicitacoes, sortConfig]);

  const handleSort = key => {
    setSortConfig(prev => ({
      key: key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const getSortIcon = key => {
    var isActive = sortConfig.key === key;
    if (!isActive || sortConfig.direction === 'desc')
      return <FaSortUp size={12} />;
    return <FaSortDown size={12} />;
  };

  const empreendimentos = useSelector(state => state.empreendimentos);

  const optionsEmpreendimentos = [
    ...empreendimentos.sort.map(item => ({
      value: item.codigo,
      label: item.codigo + ' - ' + item.descricao,
    })),
  ];

  const buscarCidades = useCallback(async () => {
    try {
      const response = await api.getCities();
      const opts = response.map(item => ({
        value: item.codigo,
        label: item.cidade,
      }));
      setCidadesOpts(opts);
    } catch (err) {
      setCidadesOpts([]);
    }
  }, []);

  useEffect(() => {
    buscarSolicitacoes({});
    buscarCidades();
  }, [buscarCidades]);

  const buscarSolicitacoes = async filtros => {
    try {
      setIsLoading(true);
      setLastFilters(filtros);
      const response = await api.consultarSolicitacoesAutoatendimentoEscritura(
        filtros
      );
      if (response) {
        setSolicitacoes(response);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenDetail = async item => {
    setItemSelecionado(item);
    setShowModalDetalhes(true);
    setIsLoadingDetalhes(true);
    setDetalhesCliente(null);

    try {
      const response = await api.obterDetalhesSolicitacaoEscritura(
        item.codigo_boleto,
        item.codigo_conta,
        item.ge
      );
      if (response) {
        setDetalhesCliente(response);

        if (
          Array.isArray(response.campos_reprovados) &&
          response.campos_reprovados.length > 0
        ) {
          setCamposReprovados(
            response.campos_reprovados
              .filter(c => !c.resolvido)
              .map(c => ({
                secao: c.secao,
                codigo_herdeiro: c.codigo_herdeiro || null,
                nome_campo: c.nome_campo,
                descricao: c.descricao,
              }))
          );
        } else {
          setCamposReprovados([]);
        }

        if (response.documentacao && response.documentacao.bytes) {
          const byteCharacters = atob(response.documentacao.bytes);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], {
            type: response.documentacao.content_type || 'application/pdf',
          });
          const url = URL.createObjectURL(blob);
          setDocumentoPreviewUrl(url);
        }
      }
    } catch (error) {
      toast.error('Erro ao carregar detalhes do cliente.');
    } finally {
      setIsLoadingDetalhes(false);
    }
  };

  const handleCloseModalDetalhes = () => {
    setShowModalDetalhes(false);
    setItemSelecionado(null);
    setDetalhesCliente(null);
    setOpenCards({
      dados: false,
      participantes: false,
      envio: false,
      documentacao: false,
      herdeiros: false,
    });
    setCamposReprovados([]);
    setAcaoSelecionada(null);
    setObservacaoAcao('');
    setEnviarEmailCliente(true);
    if (documentoPreviewUrl) {
      URL.revokeObjectURL(documentoPreviewUrl);
      setDocumentoPreviewUrl(null);
    }
  };

  const toggleCard = cardKey => {
    setOpenCards(prev => ({
      ...prev,
      [cardKey]: !prev[cardKey],
    }));
  };

  const handleSelecionarAcao = acao => {
    setAcaoSelecionada(acao);
    setObservacaoAcao('');
    setEnviarEmailCliente(true);
  };

  const handleCancelarAcao = () => {
    setAcaoSelecionada(null);
    setObservacaoAcao('');
    setEnviarEmailCliente(true);
    // mantém camposReprovados — usuario pode escolher outra acao sem perder marcacoes
  };

  const chaveCampoReprovado = campo =>
    `${campo.secao || ''}|${campo.codigo_herdeiro || 0}|${campo.nome_campo ||
      ''}`;

  const isCampoReprovadoMarcado = campo => {
    const chave = chaveCampoReprovado(campo);
    return camposReprovados.some(c => chaveCampoReprovado(c) === chave);
  };

  const toggleCampoReprovado = campo => {
    const chave = chaveCampoReprovado(campo);
    setCamposReprovados(prev => {
      const existe = prev.some(c => chaveCampoReprovado(c) === chave);
      if (existe) return prev.filter(c => chaveCampoReprovado(c) !== chave);
      return [...prev, campo];
    });
  };

  const isFluxoHerdeiros =
    detalhesCliente &&
    detalhesCliente.herdeiros &&
    detalhesCliente.herdeiros.length > 0;

  // True se o campo foi reprovado em analise anterior (e ainda nao resolvido).
  const isCampoReprovadoAnteriormente = campo => {
    if (
      !detalhesCliente ||
      !Array.isArray(detalhesCliente.campos_reprovados) ||
      detalhesCliente.campos_reprovados.length === 0
    )
      return false;
    const chave = chaveCampoReprovado(campo);
    return detalhesCliente.campos_reprovados.some(
      c => !c.resolvido && chaveCampoReprovado(c) === chave
    );
  };

  // Render compacto. Checkbox SEMPRE interativo + badge de historico para mostrar
  // o que ja estava reprovado em analise anterior (independente da marcacao atual).
  const renderCheckReprovacao = (
    secao,
    nomeCampo,
    descricao,
    codigoHerdeiro = null
  ) => {
    if (!itemSelecionado) return null;

    const campo = {
      secao,
      codigo_herdeiro: codigoHerdeiro,
      nome_campo: nomeCampo,
      descricao: descricao || nomeCampo,
    };
    const reprovadoAntes = isCampoReprovadoAnteriormente(campo);

    // Etapa 2 (Análise) + ação não-Aprovar: checkbox interativo. Os campos que
    // já estavam reprovados em análise anterior vêm pré-marcados (via
    // marcadoAgora), permitindo que o especialista desmarque os corrigidos.
    // Fora desse contexto: só badge "Reprovado" pra visibilidade.
    const naEtapaAnalise =
      itemSelecionado.etapa_atual === 2 && acaoSelecionada !== 'aprovar';
    if (!naEtapaAnalise) {
      if (!reprovadoAntes) return null;
      return (
        <span
          className="badge badge-danger ml-2"
          style={{ fontSize: '0.7em', verticalAlign: 'middle' }}
          title="Este campo foi reprovado e aguarda correção do cliente"
        >
          Reprovado
        </span>
      );
    }

    const marcadoAgora = isCampoReprovadoMarcado(campo);
    const idCheck = `chk-reprovar-${chaveCampoReprovado(campo)}`;

    const textoLabel = 'Reprovar';
    let classeLabel;
    let tituloLabel = '';
    if (marcadoAgora && reprovadoAntes) {
      classeLabel = 'text-danger font-weight-bold';
      tituloLabel = 'Continua reprovado';
    } else if (marcadoAgora) {
      classeLabel = 'text-danger';
    } else if (reprovadoAntes) {
      classeLabel = 'text-muted';
      tituloLabel = 'Será aprovado ao confirmar';
    } else {
      classeLabel = 'text-muted';
    }

    return (
      <span
        className="ml-2 d-inline-flex align-items-center"
        style={{ cursor: 'pointer' }}
      >
        <Form.Check
          type="checkbox"
          inline
          id={idCheck}
          checked={marcadoAgora}
          onChange={() => toggleCampoReprovado(campo)}
          className="mr-1 mb-0"
          label=""
        />
        <label
          htmlFor={idCheck}
          className={`mb-0 ${classeLabel}`}
          title={tituloLabel}
          style={{ cursor: 'pointer', fontSize: '0.85em' }}
        >
          {textoLabel}
        </label>
      </span>
    );
  };

  const aplicarTransicaoEtapa = (etapaAtual, aprovado) => {
    let novaEtapa = etapaAtual;
    let novoStatus = aprovado ? 2 : 3;

    if (etapaAtual === 2) {
      if (aprovado) {
        novaEtapa = 3;
        novoStatus = 1;
      } else {
        novaEtapa = 1;
        novoStatus = 1;
      }
    }

    return { novaEtapa, novoStatus };
  };

  const handleConfirmarAcao = async () => {
    try {
      const aprovado = acaoSelecionada === 'aprovar';
      if (!aprovado && isFluxoHerdeiros) {
        if (!observacaoAcao || !observacaoAcao.trim()) {
          toast.error('Informe o motivo da reprovação na observação.');
          return;
        }
        if (camposReprovados.length === 0) {
          toast.error(
            'Marque ao menos um campo reprovado na seção "Herdeiros / Espólios".'
          );
          return;
        }
      }

      setIsLoadingAcao(true);

      const usuario = AuthStorage.getUser();
      const statusEtapaValor = aprovado ? 2 : 3;
      const codigoSolicitacao = itemSelecionado.codigo;
      const isFluxoHerdeiros =
        detalhesCliente &&
        detalhesCliente.herdeiros &&
        detalhesCliente.herdeiros.length > 0;

      const dados = {
        codigo_solicitacao: codigoSolicitacao,
        etapa_atual: itemSelecionado.etapa_atual,
        status_etapa: statusEtapaValor,
        codigo_usuario_alteracao: usuario.usuario,
        aprovado: aprovado,
        observacao: observacaoAcao || '',
        enviar_email_cliente: enviarEmailCliente,
        email_cliente: itemSelecionado.email_cliente || '',
        solicitante: itemSelecionado.solicitante || '',
        aplicar_transicao_automatica: true,
        codigo_boleto: itemSelecionado.codigo_boleto,
        tipo_herdeiros: isFluxoHerdeiros,
        campos_reprovados:
          !aprovado && isFluxoHerdeiros ? camposReprovados : [],
      };

      await api.atualizarSolicitacaoEscritura(dados);

      // Atualiza estado localmente — sem recarregar a grid.
      const etapaOrigem = itemSelecionado.etapa_atual;
      let novaEtapa;
      let novoStatus;
      if (aprovado) {
        if (isFluxoHerdeiros && etapaOrigem === 2) {
          novaEtapa = 2;
          novoStatus = 2;
        } else {
          const transicao = aplicarTransicaoEtapa(etapaOrigem, true);
          novaEtapa = transicao.novaEtapa;
          novoStatus = transicao.novoStatus;
        }
      } else {
        novaEtapa = etapaOrigem;
        novoStatus = 3;
      }

      const itemAtualizado = {
        ...itemSelecionado,
        etapa_atual: novaEtapa,
        status_etapa: novoStatus,
      };
      setItemSelecionado(itemAtualizado);
      setSolicitacoes(prev =>
        prev.map(sol =>
          sol.codigo === codigoSolicitacao ? { ...sol, ...itemAtualizado } : sol
        )
      );

      // Atualiza campos_reprovados no detalhe sem nova consulta:
      // os antigos viram resolvidos; os marcados agora entram como pendentes.
      const novosCamposPendentes = aprovado
        ? []
        : (camposReprovados || []).map(c => ({
            ...c,
            resolvido: false,
          }));
      setDetalhesCliente(prev =>
        prev
          ? {
              ...prev,
              campos_reprovados: novosCamposPendentes,
            }
          : prev
      );

      toast.success(
        aprovado
          ? 'Solicitação aprovada com sucesso!'
          : 'Solicitação reprovada com sucesso!'
      );

      setAcaoSelecionada(null);
      setObservacaoAcao('');
      setEnviarEmailCliente(true);
      setCamposReprovados(novosCamposPendentes);
    } catch (error) {
      toast.error(error.message || 'Erro ao processar solicitação');
    } finally {
      setIsLoadingAcao(false);
    }
  };

  const handleOpenStatusModal = item => {
    if (isSolicitacaoFinalizada(item)) {
      toast.info(
        'Esta solicitação já foi finalizada e não pode mais ser alterada.'
      );
      return;
    }
    setItemGerenciarStatus(item);
    setEtapaSelecionadaStatus(null);
    setSubStatusSelecionado(null);
    setShowModalGerenciarStatus(true);
  };

  const handleCloseModalGerenciarStatus = () => {
    setShowModalGerenciarStatus(false);
    setItemGerenciarStatus(null);
    setEtapaSelecionadaStatus(null);
    setSubStatusSelecionado(null);
    setArquivoGerenciarStatus(null);
    if (arquivoGerenciarStatusPreview) {
      URL.revokeObjectURL(arquivoGerenciarStatusPreview);
    }
    setArquivoGerenciarStatusPreview(null);
    setObservacaoGerenciarStatus('');
    setEnviarEmailGerenciarStatus(true);
    setMensagemEmailGerenciarStatus('');
    if (fileInputGerenciarStatusRef.current) {
      fileInputGerenciarStatusRef.current.value = '';
    }
  };

  const handleFileGerenciarStatusSelect = event => {
    const file = event.target.files[0];
    if (!file) return;

    const extensoesPermitidas = ['.pdf'];
    const extensao = file.name
      .toLowerCase()
      .substring(file.name.lastIndexOf('.'));
    if (!extensoesPermitidas.includes(extensao)) {
      toast.error('Apenas arquivos PDF são permitidos.');
      event.target.value = '';
      return;
    }

    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      toast.error('O arquivo deve ter no máximo 10MB.');
      event.target.value = '';
      return;
    }

    setArquivoGerenciarStatus(file);
    const previewUrl = URL.createObjectURL(file);
    setArquivoGerenciarStatusPreview(previewUrl);
  };

  const handleRemoverArquivoGerenciarStatus = () => {
    setArquivoGerenciarStatus(null);
    if (arquivoGerenciarStatusPreview) {
      URL.revokeObjectURL(arquivoGerenciarStatusPreview);
    }
    setArquivoGerenciarStatusPreview(null);
    if (fileInputGerenciarStatusRef.current) {
      fileInputGerenciarStatusRef.current.value = '';
    }
  };

  const handleConfirmarGerenciarStatus = () => {
    if (!etapaSelecionadaStatus) {
      toast.error('Selecione uma etapa.');
      return;
    }

    if (etapaSelecionadaStatus.value === 2 && !subStatusSelecionado) {
      toast.error('Selecione se deseja aprovar ou reprovar a documentação.');
      return;
    }

    if (etapaSelecionadaStatus.value === 4 && !arquivoGerenciarStatus) {
      setShowModalAvisoSemDocumento(true);
      return;
    }

    executarGerenciarStatus();
  };

  const executarGerenciarStatus = async () => {
    try {
      setIsLoadingGerenciarStatus(true);
      setShowModalAvisoSemDocumento(false);

      const usuario = AuthStorage.getUser();
      const etapaSelecionada = etapaSelecionadaStatus.value;

      if (etapaSelecionada === 4 && arquivoGerenciarStatus) {
        const formData = new FormData();
        formData.append(arquivoGerenciarStatus.name, arquivoGerenciarStatus);

        const mensagemBase64 = mensagemEmailGerenciarStatus
          ? btoa(unescape(encodeURIComponent(mensagemEmailGerenciarStatus)))
          : '';

        formData.append(
          'dados',
          JSON.stringify({
            CodigoSolicitacao: itemGerenciarStatus.codigo,
            CodigoBoleto: itemGerenciarStatus.codigo_boleto,
            CodigoConta: itemGerenciarStatus.codigo_conta,
            GE: itemGerenciarStatus.ge,
            CodigoUsuarioAlteracao: usuario.usuario,
            Observacao:
              observacaoGerenciarStatus || 'Status alterado manualmente.',
            EnviarEmailCliente: enviarEmailGerenciarStatus,
            MensagemEmail: mensagemBase64,
            EmailCliente: itemGerenciarStatus.email_cliente || '',
          })
        );

        await api.enviarDocumentoEscritura(formData);
      } else {
        let statusEtapa = 1;

        if (etapaSelecionada === 2 && subStatusSelecionado) {
          statusEtapa = subStatusSelecionado === 'aprovar' ? 2 : 3;
        }

        if (etapaSelecionada === 4) {
          statusEtapa = 4;
        }

        const aplicarTransicaoAutomatica =
          etapaSelecionada === 2 && subStatusSelecionado !== null;

        const dados = {
          codigo_solicitacao: itemGerenciarStatus.codigo,
          etapa_atual: etapaSelecionada,
          status_etapa: statusEtapa,
          codigo_usuario_alteracao: usuario.usuario,
          aprovado:
            etapaSelecionada === 2 ? subStatusSelecionado === 'aprovar' : null,
          observacao:
            observacaoGerenciarStatus || 'Status alterado manualmente.',
          enviar_email_cliente: enviarEmailGerenciarStatus,
          email_cliente: itemGerenciarStatus.email_cliente || '',
          solicitante: itemGerenciarStatus.solicitante || '',
          aplicar_transicao_automatica: aplicarTransicaoAutomatica,
          codigo_boleto: itemGerenciarStatus.codigo_boleto,
        };

        await api.atualizarSolicitacaoEscritura(dados);
      }

      const response = await api.consultarSolicitacoesAutoatendimentoEscritura(
        lastFilters || {}
      );

      if (response) {
        setSolicitacoes(response);
      }

      toast.success('Status alterado com sucesso!');
      handleCloseModalGerenciarStatus();
    } catch (error) {
      toast.error(error.message || 'Erro ao alterar status.');
    } finally {
      setIsLoadingGerenciarStatus(false);
    }
  };

  const handleEnviarDocumento = item => {
    if (isSolicitacaoFinalizada(item)) {
      toast.info(
        'Esta solicitação já foi finalizada e não pode mais ser alterada.'
      );
      return;
    }
    if (item.etapa_atual !== 3) {
      toast.warning(
        'O envio de documento só está disponível para solicitações na Etapa 3 (Emissão e Envio da Autorização).'
      );
      return;
    }
    setItemEnviarDoc(item);
    setShowModalEnviarDoc(true);
  };

  const handleCloseModalEnviarDoc = () => {
    setShowModalEnviarDoc(false);
    setItemEnviarDoc(null);
    setArquivoSelecionado(null);
    setArquivoPreview(null);
    setEnviarEmailDocumento(false);
    setMensagemEmailDocumento('');
    setObservacaoDocumento('');
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleFileSelect = event => {
    const file = event.target.files[0];
    if (!file) return;

    const extensoesPermitidas = ['.pdf'];
    const extensao = file.name
      .toLowerCase()
      .substring(file.name.lastIndexOf('.'));
    if (!extensoesPermitidas.includes(extensao)) {
      toast.error('Apenas arquivos PDF são permitidos.');
      event.target.value = '';
      return;
    }

    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      toast.error('O arquivo deve ter no máximo 10MB.');
      event.target.value = '';
      return;
    }

    setArquivoSelecionado(file);

    const previewUrl = URL.createObjectURL(file);
    setArquivoPreview(previewUrl);
  };

  const handleRemoverArquivo = () => {
    setArquivoSelecionado(null);
    if (arquivoPreview) {
      URL.revokeObjectURL(arquivoPreview);
    }
    setArquivoPreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleConfirmarEnvioDocumento = () => {
    if (!arquivoSelecionado) {
      toast.error('Selecione um arquivo para enviar.');
      return;
    }

    if (enviarEmailDocumento) {
      setShowModalConfirmacaoEnvio(true);
      return;
    }

    executarEnvioDocumento();
  };

  const executarEnvioDocumento = async () => {
    try {
      setIsLoadingEnviarDoc(true);
      setShowModalConfirmacaoEnvio(false);

      const usuario = AuthStorage.getUser();

      const formData = new FormData();
      formData.append(arquivoSelecionado.name, arquivoSelecionado);
      const mensagemBase64 = mensagemEmailDocumento
        ? btoa(unescape(encodeURIComponent(mensagemEmailDocumento)))
        : '';

      formData.append(
        'dados',
        JSON.stringify({
          CodigoSolicitacao: itemEnviarDoc.codigo,
          CodigoBoleto: itemEnviarDoc.codigo_boleto,
          CodigoConta: itemEnviarDoc.codigo_conta,
          GE: itemEnviarDoc.ge,
          CodigoUsuarioAlteracao: usuario.usuario,
          Observacao: observacaoDocumento || 'Documento de escritura enviado.',
          EnviarEmailCliente: enviarEmailDocumento,
          MensagemEmail: mensagemBase64,
          EmailCliente: itemEnviarDoc.email_cliente || '',
        })
      );

      await api.enviarDocumentoEscritura(formData);

      const response = await api.consultarSolicitacoesAutoatendimentoEscritura(
        lastFilters || {}
      );

      if (response) {
        setSolicitacoes(response);
      }

      toast.success('Documento enviado com sucesso!');
      handleCloseModalEnviarDoc();
    } catch (error) {
      toast.error(error.message || 'Erro ao enviar documento.');
    } finally {
      setIsLoadingEnviarDoc(false);
    }
  };

  if (!temPermissao) {
    return (
      <>
        <Header title={'Solicitações de Escritura'} />
        <div className="container-fluid">
          <Row className="justify-content-center mt-5">
            <Col xs={12} md={6} lg={4}>
              <Card className="text-center border-danger">
                <Card.Body className="py-5">
                  <FaLock size={60} color="#dc3545" className="mb-4" />
                  <h4 className="text-danger mb-3">Acesso Negado</h4>
                  <p className="text-muted mb-0">
                    Você não possui permissão para acessar esta funcionalidade.
                  </p>
                  <p className="text-muted">
                    Entre em contato com o administrador do sistema para
                    solicitar acesso.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }

  return (
    <>
      <Header title={'Solicitações de Escritura'} />
      <div className="container-fluid">
        <div className="CardProdutividadeFiltro">
          <Card>
            <Card.Body>
              <Formik
                onSubmit={values => buscarSolicitacoes(values)}
                initialValues={{
                  codigo_solicitacao: '',
                  codigo_cidade: '',
                  codigo_empreendimento: '',
                  cpf_cnpj: '',
                  data_inicial: '',
                  data_final: '',
                  etapa_atual: '',
                  status_etapa: '',
                }}
              >
                {({
                  handleSubmit,
                  values,
                  setFieldValue,
                  handleChange,
                  resetForm,
                  errors,
                  touched,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Row className="align-items-end">
                      <Col xs="12" md="2">
                        <Form.Group controlId="search.codigo_solicitacao">
                          <Form.Label>Cód. Solicitação</Form.Label>
                          <Form.Control
                            name="codigo_solicitacao"
                            type="number"
                            placeholder="Ex.: 123"
                            value={values.codigo_solicitacao}
                            onChange={handleChange}
                            disabled={isLoading}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="2">
                        <Form.Group controlId="search.codigo_cidade">
                          <Form.Label>Cidade</Form.Label>
                          <Select
                            placeholder={
                              !cidadesOpts.length ? 'Carregando...' : 'Todos...'
                            }
                            isDisabled={!cidadesOpts.length || isLoading}
                            isClearable
                            options={cidadesOpts}
                            value={
                              cidadesOpts.find(
                                opt => opt.value == values.codigo_cidade
                              ) || null
                            }
                            onChange={option =>
                              setFieldValue(
                                'codigo_cidade',
                                option ? option.value : ''
                              )
                            }
                            styles={customStyles}
                            components={{ DropdownIndicator }}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="3">
                        <Form.Group controlId="search.codigo_empreendimento">
                          <Form.Label>Empreendimento</Form.Label>
                          <Select
                            placeholder={
                              !optionsEmpreendimentos.length
                                ? 'Carregando...'
                                : 'Todos...'
                            }
                            isDisabled={
                              !optionsEmpreendimentos.length || isLoading
                            }
                            isClearable
                            options={optionsEmpreendimentos}
                            value={
                              optionsEmpreendimentos.find(
                                opt => opt.value == values.codigo_empreendimento
                              ) || null
                            }
                            onChange={selectedOption =>
                              setFieldValue(
                                'codigo_empreendimento',
                                selectedOption ? selectedOption.value : ''
                              )
                            }
                            styles={customStyles}
                            components={{ DropdownIndicator }}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="5">
                        <Form.Group controlId="search.cpf_cnpj">
                          <Form.Label>CPF/CNPJ</Form.Label>
                          <Form.Control
                            name="cpf_cnpj"
                            type="text"
                            placeholder="Buscar por CPF ou CNPJ"
                            value={values.cpf_cnpj}
                            onChange={handleChange}
                            disabled={isLoading}
                            className={`form-control ${errors.cpf_cnpj &&
                              touched.cpf_cnpj &&
                              'is-invalid'}`}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.cpf_cnpj}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="align-items-end">
                      <Col xs="12" md="4">
                        <Form.Label>Período Solicitação</Form.Label>
                        <InputGroup>
                          <div>
                            <DateMask
                              initialValue={values.data_inicial}
                              allowEmpty
                              onValidate={value =>
                                setFieldValue('data_inicial', value)
                              }
                            >
                              {({ dateError, dateValue, setDate }) => (
                                <Form.Group controlId="search.data_inicial">
                                  <MaskedInput
                                    name="data_inicial"
                                    type="tel"
                                    required={false}
                                    guide={false}
                                    disabled={isLoading}
                                    className={`form-control ${((errors.data_inicial &&
                                      touched.data_inicial) ||
                                      dateError) &&
                                      'is-invalid'}`}
                                    placeholder="Ex.: 01/01/2025"
                                    mask={constants.MASK_DATE}
                                    value={dateValue}
                                    onChange={e => setDate(e.target.value)}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors.data_inicial}
                                  </Form.Control.Feedback>
                                  <Form.Control.Feedback type="invalid">
                                    {dateError}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              )}
                            </DateMask>
                          </div>
                          <div className="text-center px-0">
                            <span className="input-group-text">a</span>
                          </div>
                          <div>
                            <DateMask
                              initialValue={values.data_final}
                              allowEmpty
                              onValidate={value =>
                                setFieldValue('data_final', value)
                              }
                            >
                              {({ dateError, dateValue, setDate }) => (
                                <Form.Group controlId="search.data_final">
                                  <MaskedInput
                                    name="data_final"
                                    type="tel"
                                    required={false}
                                    guide={false}
                                    disabled={isLoading}
                                    className={`form-control ${((errors.data_final &&
                                      touched.data_final) ||
                                      dateError) &&
                                      'is-invalid'}`}
                                    placeholder="Ex.: 01/01/2025"
                                    mask={constants.MASK_DATE}
                                    value={dateValue}
                                    onChange={e => setDate(e.target.value)}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors.data_final}
                                  </Form.Control.Feedback>
                                  <Form.Control.Feedback type="invalid">
                                    {dateError}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              )}
                            </DateMask>
                          </div>
                        </InputGroup>
                      </Col>
                      <Col xs="12" md="4">
                        <Form.Group controlId="search.etapa_atual">
                          <Form.Label>Etapa Atual</Form.Label>
                          <Select
                            placeholder="Todos"
                            isClearable
                            isDisabled={isLoading}
                            options={ETAPAS_OPTIONS}
                            value={
                              ETAPAS_OPTIONS.find(
                                o => o.value === values.etapa_atual
                              ) || null
                            }
                            onChange={option =>
                              setFieldValue(
                                'etapa_atual',
                                option ? option.value : ''
                              )
                            }
                            styles={customStyles}
                            components={{ DropdownIndicator }}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="4">
                        <Form.Group controlId="search.status_etapa">
                          <Form.Label>Status da Etapa</Form.Label>
                          <Select
                            placeholder="Todos"
                            isClearable
                            isDisabled={isLoading}
                            options={SUBETAPAS_OPTIONS}
                            value={
                              SUBETAPAS_OPTIONS.find(
                                o => o.value === values.status_etapa
                              ) || null
                            }
                            onChange={option =>
                              setFieldValue(
                                'status_etapa',
                                option ? option.value : ''
                              )
                            }
                            styles={customStyles}
                            components={{ DropdownIndicator }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="justify-content-end">
                      <Col xs="12" lg="auto" className="text-right">
                        <Form.Group>
                          <Button
                            disabled={isLoading}
                            variant="success"
                            type="submit"
                            className="ml-2"
                          >
                            {isLoading ? (
                              <>
                                <Spinner animation="border" size="sm" />
                                <span>&nbsp;Buscando...</span>
                              </>
                            ) : (
                              <>
                                <FaSearch />
                                <span>&nbsp;Buscar</span>
                              </>
                            )}
                          </Button>
                          <Button
                            variant="outline-secondary"
                            className="ml-2"
                            disabled={isLoading}
                            onClick={() => {
                              resetForm();
                              setSolicitacoes([]);
                              setLastFilters(null);
                            }}
                          >
                            Limpar Filtros
                          </Button>
                        </Form.Group>
                      </Col>
                    </Row>
                  </form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </div>

        <Row className="p-4">
          {error ? (
            <Col className="text-center">
              <div className="alert alert-danger">{error}</div>
            </Col>
          ) : isLoading ? (
            <Col className="text-center py-5">
              <Spinner animation="border" variant="primary" />
              <p className="text-muted mt-3 mb-0">Carregando...</p>
            </Col>
          ) : solicitacoes.length > 0 ? (
            <Col xs={12} className="table-responsive">
              <Table
                className="table table-striped table-bordered table-hover table-sm"
                style={{ fontSize: '0.75rem' }}
              >
                <Thead>
                  <Tr className="text-center">
                    <Th
                      onClick={() => handleSort('codigo')}
                      style={{ cursor: 'pointer' }}
                    >
                      Nº {getSortIcon('codigo')}
                    </Th>
                    <Th
                      onClick={() => handleSort('tipo_envio')}
                      style={{ cursor: 'pointer' }}
                    >
                      Tipo {getSortIcon('tipo_envio')}
                    </Th>
                    <Th
                      onClick={() => handleSort('data')}
                      style={{ cursor: 'pointer' }}
                    >
                      Data {getSortIcon('data')}
                    </Th>
                    <Th
                      onClick={() => handleSort('etapa_atual')}
                      style={{ cursor: 'pointer' }}
                    >
                      Etapa {getSortIcon('etapa_atual')}
                    </Th>
                    <Th
                      onClick={() => handleSort('status_etapa')}
                      style={{ cursor: 'pointer' }}
                    >
                      Status {getSortIcon('status_etapa')}
                    </Th>
                    <Th
                      onClick={() => handleSort('solicitante')}
                      style={{ cursor: 'pointer' }}
                    >
                      Solicitante {getSortIcon('solicitante')}
                    </Th>
                    <Th
                      onClick={() => handleSort('perfil_cliente')}
                      style={{ cursor: 'pointer' }}
                    >
                      Perfil {getSortIcon('perfil_cliente')}
                    </Th>
                    <Th
                      onClick={() => handleSort('cidade')}
                      style={{ cursor: 'pointer' }}
                    >
                      Cidade {getSortIcon('cidade')}
                    </Th>
                    <Th
                      onClick={() => handleSort('empreendimento')}
                      style={{ cursor: 'pointer' }}
                    >
                      Empreendimento {getSortIcon('empreendimento')}
                    </Th>
                    <Th
                      onClick={() => handleSort('cpf')}
                      style={{ cursor: 'pointer' }}
                    >
                      CPF/CNPJ {getSortIcon('cpf')}
                    </Th>
                    <Th
                      onClick={() => handleSort('especialista_responsavel')}
                      style={{ cursor: 'pointer' }}
                    >
                      Especialista {getSortIcon('especialista_responsavel')}
                    </Th>
                    <Th>Detalhes</Th>
                    <Th>Doc. Digital</Th>
                    {/* <Th>Gerenciar Status</Th> */}
                    <Th>Enviar Doc.</Th>
                  </Tr>
                </Thead>
                <Tbody className="text-center">
                  {sortedSolicitacoes.map((item, idx) => (
                    <Tr key={item.codigo || idx}>
                      <Td>{item.codigo}</Td>
                      <Td>{getDescricaoTipoEnvio(item.tipo_envio)}</Td>
                      <Td style={{ whiteSpace: 'nowrap' }}>
                        {format.datetime(item.data)}
                      </Td>
                      <Td>
                        {isFluxoHerdeirosFinalizado(item)
                          ? renderFinalizadoPill()
                          : getDescricaoEtapa(item.etapa_atual)}
                      </Td>
                      <Td>
                        {isFluxoHerdeirosFinalizado(item)
                          ? ''
                          : getDescricaoStatus(item.status_etapa)}
                      </Td>
                      <Td>{item.solicitante}</Td>
                      <Td>{getDescricaoPerfilCliente(item.perfil_cliente)}</Td>
                      <Td>{item.cidade}</Td>
                      <Td>
                        {item.empreendimento}
                        {item.quadra || item.lote
                          ? ' - ' + item.quadra + '/' + item.lote
                          : ''}
                      </Td>
                      <Td style={{ whiteSpace: 'nowrap' }}>
                        {format.cpf(item.cpf)}
                      </Td>
                      <Td>{item.especialista_responsavel || '-'}</Td>
                      <Td>
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={() => handleOpenDetail(item)}
                          title="Ver detalhes"
                        >
                          <FaSearch color="#0747a6" size={18} />
                        </Button>
                      </Td>
                      <Td>
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={() => {
                            setItemDocDigital(item);
                            setShowModalDocDigital(true);
                          }}
                          title={
                            item.codigo_documento_digital
                              ? 'Documento Digital'
                              : 'Documento Digital não disponível'
                          }
                          disabled={!item.codigo_documento_digital}
                        >
                          <FaFileSignature
                            color={
                              item.codigo_documento_digital ? '#0747a6' : '#ccc'
                            }
                            size={18}
                          />
                        </Button>
                      </Td>
                      {/* <Td>
                        <Button
                          variant={
                            isSolicitacaoFinalizada(item)
                              ? 'outline-secondary'
                              : 'outline-primary'
                          }
                          size="sm"
                          onClick={() => handleOpenStatusModal(item)}
                          title={
                            isSolicitacaoFinalizada(item)
                              ? 'Solicitação finalizada'
                              : 'Gerenciar status'
                          }
                          disabled={isSolicitacaoFinalizada(item)}
                        >
                          <FaCog />
                        </Button>
                      </Td> */}
                      <Td>
                        <Button
                          variant={
                            item.etapa_atual === 3
                              ? 'outline-success'
                              : 'outline-secondary'
                          }
                          size="sm"
                          onClick={() => handleEnviarDocumento(item)}
                          title={
                            isSolicitacaoFinalizada(item)
                              ? 'Solicitação finalizada'
                              : item.etapa_atual === 3
                              ? 'Enviar documento'
                              : 'Disponível apenas na Etapa 3'
                          }
                          disabled={
                            item.etapa_atual !== 3 ||
                            isSolicitacaoFinalizada(item)
                          }
                        >
                          <FaFileUpload />
                        </Button>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </Col>
          ) : lastFilters ? (
            <Col className="text-center">
              <p className="text-muted">Nenhuma solicitação encontrada</p>
            </Col>
          ) : (
            <Col className="text-center">
              <p className="text-muted">
                Utilize os filtros acima para buscar solicitações
              </p>
            </Col>
          )}
        </Row>
      </div>

      <Modal
        show={showModalDetalhes}
        onHide={handleCloseModalDetalhes}
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaInfoCircle color="#17a2b8" style={{ marginRight: '8px' }} />
            Detalhes da Solicitação
            {itemSelecionado && (
              <span className="text-muted ml-2" style={{ fontSize: '0.7em' }}>
                (Nº {itemSelecionado.codigo})
              </span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {itemSelecionado && (
            <Tabs defaultActiveKey="formulario" id="tabs-detalhes-solicitacao">
              <Tab eventKey="formulario" title="Formulário">
                <div className="pt-3">
                  {/* Card Fixo - Informações da Solicitação */}
                  <Card
                    className="mb-3"
                    style={{ borderLeft: '4px solid #0d6efd' }}
                  >
                    <Card.Body className="py-2 px-3">
                      <Row className="align-items-center mb-2">
                        <Col xs={6} md={6}>
                          <small
                            className="text-muted d-block"
                            style={{
                              fontSize: '0.7em',
                              textTransform: 'uppercase',
                            }}
                          >
                            Etapa
                          </small>
                          <span
                            style={{ fontSize: '0.85em', fontWeight: '600' }}
                          >
                            {getDescricaoEtapa(itemSelecionado.etapa_atual)}
                          </span>
                        </Col>
                        <Col xs={6} md={6}>
                          <small
                            className="text-muted d-block"
                            style={{
                              fontSize: '0.7em',
                              textTransform: 'uppercase',
                            }}
                          >
                            Status
                          </small>
                          <span
                            style={{ fontSize: '0.85em', fontWeight: '600' }}
                          >
                            {getDescricaoStatus(itemSelecionado.status_etapa)}
                          </span>
                        </Col>
                      </Row>
                      <Row className="align-items-center">
                        <Col xs={6} md={6}>
                          <small
                            className="text-muted d-block"
                            style={{
                              fontSize: '0.7em',
                              textTransform: 'uppercase',
                            }}
                          >
                            Data
                          </small>
                          <span
                            style={{ fontSize: '0.85em', fontWeight: '600' }}
                          >
                            {format.datetime(itemSelecionado.data)}
                          </span>
                        </Col>
                        <Col xs={6} md={6}>
                          <small
                            className="text-muted d-block"
                            style={{
                              fontSize: '0.7em',
                              textTransform: 'uppercase',
                            }}
                          >
                            Responsável
                          </small>
                          <span
                            style={{ fontSize: '0.85em', fontWeight: '600' }}
                          >
                            {itemSelecionado.especialista_responsavel || '-'}
                          </span>
                        </Col>
                        <Col xs={6} md={6}>
                          <small
                            className="text-muted d-block"
                            style={{
                              fontSize: '0.7em',
                              textTransform: 'uppercase',
                            }}
                          >
                            Ge/Conta
                          </small>
                          <span
                            style={{ fontSize: '0.85em', fontWeight: '600' }}
                          >
                            {itemSelecionado.ge} /{' '}
                            {itemSelecionado.codigo_conta}
                          </span>
                        </Col>
                        <Col xs={6} md={6}>
                          <small
                            className="text-muted d-block"
                            style={{
                              fontSize: '0.7em',
                              textTransform: 'uppercase',
                            }}
                          >
                            Boleto
                          </small>
                          <span
                            style={{ fontSize: '0.85em', fontWeight: '600' }}
                          >
                            {itemSelecionado.codigo_boleto}
                          </span>
                        </Col>
                        <Col xs={6} md={6}>
                          <small
                            className="text-muted d-block"
                            style={{
                              fontSize: '0.7em',
                              textTransform: 'uppercase',
                            }}
                          >
                            Empreendimento
                          </small>
                          <span
                            style={{ fontSize: '0.85em', fontWeight: '600' }}
                          >
                            {itemSelecionado.empreendimento || '-'}
                          </span>
                        </Col>
                        <Col xs={6} md={6}>
                          <small
                            className="text-muted d-block"
                            style={{
                              fontSize: '0.7em',
                              textTransform: 'uppercase',
                            }}
                          >
                            Quadra/Lote
                          </small>
                          <span
                            style={{ fontSize: '0.85em', fontWeight: '600' }}
                          >
                            {itemSelecionado.quadra || itemSelecionado.lote
                              ? (itemSelecionado.quadra || '') +
                                ' / ' +
                                (itemSelecionado.lote || '')
                              : '-'}
                          </span>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>

                  {/* Loading Spinner */}
                  {isLoadingDetalhes ? (
                    <div className="text-center py-5">
                      <Spinner animation="border" variant="primary" />
                      <p className="text-muted mt-3 mb-0">
                        Carregando dados...
                      </p>
                    </div>
                  ) : (
                    <>
                      {/* Card 1 - Dados Pessoais */}
                      <Card className="mb-2">
                        <Card.Header
                          onClick={() => toggleCard('dados')}
                          className="d-flex justify-content-between align-items-center"
                          style={{ cursor: 'pointer' }}
                        >
                          <span>
                            <FaUser className="mr-2" color="#17a2b8" />
                            <strong>Dados Pessoais</strong>
                          </span>
                          <FaChevronDown
                            style={{
                              transition: 'transform 0.3s ease',
                              transform: openCards.dados
                                ? 'rotate(180deg)'
                                : 'rotate(0deg)',
                            }}
                          />
                        </Card.Header>
                        <Collapse in={openCards.dados}>
                          <div>
                            <Card.Body style={{ fontSize: '0.85em' }}>
                              {!isFluxoHerdeiros && detalhesCliente && (
                                <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                                  <FaUser className="mr-2" color="#17a2b8" />
                                  <small className="text-muted mr-2">
                                    Tipo de Solicitação:
                                  </small>
                                  <strong>Titular</strong>
                                </div>
                              )}
                              {detalhesCliente &&
                              detalhesCliente.dados_pessoais ? (
                                <>
                                  <Row>
                                    <Col md={12} className="mb-2">
                                      <small className="text-muted">Nome</small>
                                      <div>
                                        <strong>
                                          {detalhesCliente.dados_pessoais
                                            .nome || '-'}
                                        </strong>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col md={6} className="mb-2">
                                      <small className="text-muted">
                                        CPF/CNPJ
                                      </small>
                                      <div>
                                        {format.cpf(
                                          detalhesCliente.dados_pessoais.cpf
                                        ) || '-'}
                                      </div>
                                    </Col>
                                    <Col md={6} className="mb-2">
                                      <small className="text-muted">RG</small>
                                      <div>
                                        {detalhesCliente.dados_pessoais.rg ||
                                          '-'}
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col md={6} className="mb-2">
                                      <small className="text-muted">
                                        Estado Civil
                                      </small>
                                      <div>
                                        {detalhesCliente.dados_pessoais
                                          .estado_civil_descricao || '-'}
                                      </div>
                                    </Col>
                                    <Col md={6} className="mb-2">
                                      <small className="text-muted">
                                        Data Nascimento
                                      </small>
                                      <div>
                                        {detalhesCliente.dados_pessoais
                                          .data_nascimento || '-'}
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col md={6} className="mb-2">
                                      <small className="text-muted">
                                        Profissao
                                      </small>
                                      <div>
                                        {detalhesCliente.dados_pessoais
                                          .profissao || '-'}
                                      </div>
                                    </Col>
                                    <Col md={6} className="mb-2">
                                      <small className="text-muted">
                                        Nacionalidade
                                      </small>
                                      <div>
                                        {detalhesCliente.dados_pessoais
                                          .nacionalidade || '-'}
                                      </div>
                                    </Col>
                                  </Row>
                                  <hr />
                                  <Row>
                                    <Col md={12} className="mb-2">
                                      <small className="text-muted">
                                        Email
                                      </small>
                                      <div>
                                        {detalhesCliente.dados_pessoais.email ||
                                          '-'}
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col md={4} className="mb-2">
                                      <small className="text-muted">
                                        Telefone
                                      </small>
                                      <div>
                                        {format.phone(
                                          detalhesCliente.dados_pessoais
                                            .telefone
                                        ) || '-'}
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-2">
                                      <small className="text-muted">
                                        Celular
                                      </small>
                                      <div>
                                        {format.celular(
                                          detalhesCliente.dados_pessoais
                                            .telefone_celular
                                        ) || '-'}
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-2">
                                      <small className="text-muted">
                                        Comercial
                                      </small>
                                      <div>
                                        {format.phone(
                                          detalhesCliente.dados_pessoais
                                            .telefone_comercial
                                        ) || '-'}
                                      </div>
                                    </Col>
                                  </Row>
                                  <hr />
                                  <Row>
                                    <Col md={3} className="mb-2">
                                      <small className="text-muted">CEP</small>
                                      <div>
                                        {detalhesCliente.dados_pessoais.cep ||
                                          '-'}
                                      </div>
                                    </Col>
                                    <Col md={6} className="mb-2">
                                      <small className="text-muted">
                                        Logradouro
                                      </small>
                                      <div>
                                        {detalhesCliente.dados_pessoais
                                          .logradouro || '-'}
                                      </div>
                                    </Col>
                                    <Col md={3} className="mb-2">
                                      <small className="text-muted">
                                        Numero
                                      </small>
                                      <div>
                                        {detalhesCliente.dados_pessoais
                                          .numero || '-'}
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col md={4} className="mb-2">
                                      <small className="text-muted">
                                        Bairro
                                      </small>
                                      <div>
                                        {detalhesCliente.dados_pessoais
                                          .bairro || '-'}
                                      </div>
                                    </Col>
                                    <Col md={5} className="mb-2">
                                      <small className="text-muted">
                                        Cidade
                                      </small>
                                      <div>
                                        {detalhesCliente.dados_pessoais
                                          .cidade || '-'}
                                      </div>
                                    </Col>
                                    <Col md={3} className="mb-2">
                                      <small className="text-muted">
                                        Estado
                                      </small>
                                      <div>
                                        {detalhesCliente.dados_pessoais
                                          .estado || '-'}
                                      </div>
                                    </Col>
                                  </Row>
                                </>
                              ) : (
                                <p className="text-muted text-center">
                                  Nenhum dado disponivel
                                </p>
                              )}
                            </Card.Body>
                          </div>
                        </Collapse>
                      </Card>

                      {/* Card 2 - Demais Participantes */}
                      <Card className="mb-2">
                        <Card.Header
                          onClick={() => toggleCard('participantes')}
                          className="d-flex justify-content-between align-items-center"
                          style={{ cursor: 'pointer' }}
                        >
                          <span>
                            <FaUsers className="mr-2" color="#17a2b8" />
                            <strong>Demais Participantes</strong>
                            {detalhesCliente &&
                              detalhesCliente.participantes &&
                              detalhesCliente.participantes.length > 0 && (
                                <Badge variant="secondary" className="ml-2">
                                  {detalhesCliente.participantes.length}
                                </Badge>
                              )}
                          </span>
                          <FaChevronDown
                            style={{
                              transition: 'transform 0.3s ease',
                              transform: openCards.participantes
                                ? 'rotate(180deg)'
                                : 'rotate(0deg)',
                            }}
                          />
                        </Card.Header>
                        <Collapse in={openCards.participantes}>
                          <div>
                            <Card.Body style={{ fontSize: '0.85em' }}>
                              {detalhesCliente &&
                              detalhesCliente.participantes &&
                              detalhesCliente.participantes.length > 0 ? (
                                detalhesCliente.participantes.map(
                                  (part, idx) => (
                                    <div
                                      key={idx}
                                      className="mb-3 p-2"
                                      style={{
                                        borderLeft: '3px solid #17a2b8',
                                        backgroundColor: '#f8f9fa',
                                      }}
                                    >
                                      <div className="d-flex justify-content-between align-items-center mb-2">
                                        <strong>{part.nome}</strong>
                                        <Badge variant="secondary">
                                          {part.tipo}
                                        </Badge>
                                      </div>
                                      <Row>
                                        <Col md={6}>
                                          <small className="text-muted">
                                            Estado Civil
                                          </small>
                                          <div>
                                            {part.estado_civil_descricao || '-'}
                                          </div>
                                        </Col>
                                        <Col md={6}>
                                          <small className="text-muted">
                                            CPF/CNPJ
                                          </small>
                                          <div>
                                            {part.cpf
                                              ? format.cpf(part.cpf)
                                              : '-'}
                                          </div>
                                        </Col>
                                      </Row>
                                    </div>
                                  )
                                )
                              ) : (
                                <p className="text-muted text-center">
                                  Nenhum participante vinculado
                                </p>
                              )}
                            </Card.Body>
                          </div>
                        </Collapse>
                      </Card>

                      {/* Card 3 - Forma de Envio */}
                      <Card className="mb-2">
                        <Card.Header
                          onClick={() => toggleCard('envio')}
                          className="d-flex justify-content-between align-items-center"
                          style={{ cursor: 'pointer' }}
                        >
                          <span>
                            <FaEnvelope className="mr-2" color="#17a2b8" />
                            <strong>Forma de Envio</strong>
                          </span>
                          <FaChevronDown
                            style={{
                              transition: 'transform 0.3s ease',
                              transform: openCards.envio
                                ? 'rotate(180deg)'
                                : 'rotate(0deg)',
                            }}
                          />
                        </Card.Header>
                        <Collapse in={openCards.envio}>
                          <div>
                            <Card.Body style={{ fontSize: '0.85em' }}>
                              {detalhesCliente &&
                              detalhesCliente.forma_envio ? (
                                <>
                                  <Row>
                                    <Col md={6} className="mb-2">
                                      <small className="text-muted">
                                        Tipo de Envio
                                      </small>
                                      <div>
                                        <strong>
                                          {detalhesCliente.forma_envio
                                            .tipo_envio || '-'}
                                        </strong>
                                      </div>
                                    </Col>
                                    <Col md={6} className="mb-2">
                                      <small className="text-muted">
                                        Email
                                      </small>
                                      <div>
                                        {detalhesCliente.forma_envio
                                          .email_envio || '-'}
                                      </div>
                                    </Col>
                                  </Row>
                                  {detalhesCliente.forma_envio
                                    .codigo_tipo_envio === 1 && (
                                    <>
                                      <hr />
                                      <small className="text-muted d-block mb-2">
                                        Endereco de Envio
                                      </small>
                                      <Row>
                                        <Col md={3} className="mb-2">
                                          <small className="text-muted">
                                            CEP
                                          </small>
                                          <div>
                                            {detalhesCliente.forma_envio.cep ||
                                              '-'}
                                          </div>
                                        </Col>
                                        <Col md={6} className="mb-2">
                                          <small className="text-muted">
                                            Logradouro
                                          </small>
                                          <div>
                                            {detalhesCliente.forma_envio
                                              .logradouro || '-'}
                                          </div>
                                        </Col>
                                        <Col md={3} className="mb-2">
                                          <small className="text-muted">
                                            Numero
                                          </small>
                                          <div>
                                            {detalhesCliente.forma_envio
                                              .numero || '-'}
                                          </div>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col md={4} className="mb-2">
                                          <small className="text-muted">
                                            Bairro
                                          </small>
                                          <div>
                                            {detalhesCliente.forma_envio
                                              .bairro || '-'}
                                          </div>
                                        </Col>
                                        <Col md={5} className="mb-2">
                                          <small className="text-muted">
                                            Cidade
                                          </small>
                                          <div>
                                            {detalhesCliente.forma_envio
                                              .cidade || '-'}
                                          </div>
                                        </Col>
                                        <Col md={3} className="mb-2">
                                          <small className="text-muted">
                                            Estado
                                          </small>
                                          <div>
                                            {detalhesCliente.forma_envio
                                              .estado || '-'}
                                          </div>
                                        </Col>
                                      </Row>
                                    </>
                                  )}
                                </>
                              ) : (
                                <p className="text-muted text-center">
                                  Nenhuma forma de envio disponivel
                                </p>
                              )}
                            </Card.Body>
                          </div>
                        </Collapse>
                      </Card>

                      {detalhesCliente &&
                        detalhesCliente.documentacao &&
                        detalhesCliente.documentacao.possui_documento &&
                        !isFluxoHerdeiros && (
                          <Card className="mb-2">
                            <Card.Header
                              onClick={() => toggleCard('documentacao')}
                              className="d-flex justify-content-between align-items-center"
                              style={{ cursor: 'pointer' }}
                            >
                              <span>
                                <FaFileAlt className="mr-2" color="#17a2b8" />
                                <strong>Documentação Informada</strong>
                              </span>
                              <FaChevronDown
                                style={{
                                  transition: 'transform 0.3s ease',
                                  transform: openCards.documentacao
                                    ? 'rotate(180deg)'
                                    : 'rotate(0deg)',
                                }}
                              />
                            </Card.Header>
                            <Collapse in={openCards.documentacao}>
                              <div>
                                <Card.Body style={{ fontSize: '0.85em' }}>
                                  <Row>
                                    <Col md={12}>
                                      <small className="text-muted">Tipo</small>
                                      <div>
                                        <strong>
                                          {detalhesCliente.documentacao
                                            .tipo_documento || 'Titular'}
                                        </strong>
                                      </div>
                                      <small className="text-muted mt-2 d-block">
                                        Documento comprobatório anexado pelo
                                        cliente
                                      </small>
                                    </Col>
                                  </Row>
                                  {/* Visualização do documento */}
                                  {documentoPreviewUrl && (
                                    <Row className="mt-3">
                                      <Col md={12}>
                                        <div
                                          className="border rounded p-3"
                                          style={{ backgroundColor: '#f8f9fa' }}
                                        >
                                          <div className="d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center">
                                              <FaFilePdf
                                                size={32}
                                                color="#dc3545"
                                                className="mr-3"
                                              />
                                              <div>
                                                <strong>
                                                  {detalhesCliente.documentacao
                                                    .nome_arquivo ||
                                                    'Documento.pdf'}
                                                </strong>
                                                <br />
                                                <small className="text-muted">
                                                  Clique para visualizar
                                                </small>
                                              </div>
                                            </div>
                                            <Button
                                              variant="outline-info"
                                              size="sm"
                                              onClick={() =>
                                                window.open(
                                                  documentoPreviewUrl,
                                                  '_blank'
                                                )
                                              }
                                              title="Visualizar documento"
                                            >
                                              <FaEye className="mr-1" />
                                              Visualizar
                                            </Button>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                </Card.Body>
                              </div>
                            </Collapse>
                          </Card>
                        )}

                      {detalhesCliente &&
                        detalhesCliente.herdeiros &&
                        detalhesCliente.herdeiros.length > 0 && (
                          <Card className="mb-2">
                            <Card.Header
                              onClick={() => toggleCard('herdeiros')}
                              className="d-flex justify-content-between align-items-center"
                              style={{ cursor: 'pointer' }}
                            >
                              <span>
                                <FaUserFriends
                                  className="mr-2"
                                  color="#6f42c1"
                                />
                                <strong>
                                  Herdeiros / Espolios (
                                  {detalhesCliente.herdeiros.length})
                                </strong>
                              </span>
                              <FaChevronDown
                                style={{
                                  transition: 'transform 0.3s ease',
                                  transform: openCards.herdeiros
                                    ? 'rotate(180deg)'
                                    : 'rotate(0deg)',
                                }}
                              />
                            </Card.Header>
                            <Collapse in={openCards.herdeiros}>
                              <div>
                                <Card.Body style={{ fontSize: '0.85em' }}>
                                  <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                                    <FaUserFriends
                                      className="mr-2"
                                      color="#6f42c1"
                                    />
                                    <small className="text-muted mr-2">
                                      Tipo de Solicitação:
                                    </small>
                                    <strong>Herdeiros / Espólios</strong>
                                  </div>
                                  {detalhesCliente.documentacao &&
                                    detalhesCliente.documentacao
                                      .possui_documento && (
                                      <div
                                        className="border rounded p-3 mb-3"
                                        style={{ backgroundColor: '#f8f9fa' }}
                                      >
                                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                                          <div className="d-flex align-items-center">
                                            <FaFilePdf
                                              size={28}
                                              color="#dc3545"
                                              className="mr-3"
                                            />
                                            <div>
                                              <strong>
                                                Documento de Comprovação
                                                {renderCheckReprovacao(
                                                  'Documentacao',
                                                  'Documento',
                                                  'Documento de Comprovação'
                                                )}
                                              </strong>
                                              <div
                                                className="text-muted"
                                                style={{ fontSize: '0.9em' }}
                                              >
                                                {detalhesCliente.documentacao
                                                  .nome_arquivo ||
                                                  'Documento.pdf'}
                                              </div>
                                              <small className="text-muted">
                                                Formal de Partilha, Carta de Sentença, Escritura de Inventário etc.
                                              </small>
                                            </div>
                                          </div>
                                          {documentoPreviewUrl && (
                                            <Button
                                              variant="outline-info"
                                              size="sm"
                                              onClick={() =>
                                                window.open(
                                                  documentoPreviewUrl,
                                                  '_blank'
                                                )
                                              }
                                              title="Visualizar documento"
                                            >
                                              <FaEye className="mr-1" />
                                              Visualizar
                                            </Button>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  {detalhesCliente.herdeiros.map(
                                    (herdeiro, idx) => (
                                      <div
                                        key={`herdeiro-${herdeiro.codigo ||
                                          idx}`}
                                        className="border rounded p-3 mb-3"
                                        style={{ backgroundColor: '#f8f9fa' }}
                                      >
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                          <strong>
                                            Herdeiro {herdeiro.ordem || idx + 1}
                                          </strong>
                                        </div>
                                        <Row>
                                          <Col md={6}>
                                            <small className="text-muted">
                                              Nome Completo
                                              {renderCheckReprovacao(
                                                'Herdeiro',
                                                'NomeCompleto',
                                                'Nome Completo',
                                                herdeiro.codigo
                                              )}
                                            </small>
                                            <div>
                                              <strong>
                                                {herdeiro.nome_completo || '-'}
                                              </strong>
                                            </div>
                                          </Col>
                                          <Col md={3}>
                                            <small className="text-muted">
                                              CPF
                                              {renderCheckReprovacao(
                                                'Herdeiro',
                                                'CPF',
                                                'CPF',
                                                herdeiro.codigo
                                              )}
                                            </small>
                                            <div>{herdeiro.cpf || '-'}</div>
                                          </Col>
                                          <Col md={3}>
                                            <small className="text-muted">
                                              RG
                                              {renderCheckReprovacao(
                                                'Herdeiro',
                                                'RG',
                                                'RG',
                                                herdeiro.codigo
                                              )}
                                            </small>
                                            <div>{herdeiro.rg || '-'}</div>
                                          </Col>
                                        </Row>
                                        <Row className="mt-2">
                                          <Col md={12}>
                                            <small className="text-muted">
                                              E-mail
                                              {renderCheckReprovacao(
                                                'Herdeiro',
                                                'Email',
                                                'E-mail',
                                                herdeiro.codigo
                                              )}
                                            </small>
                                            <div>{herdeiro.email || '-'}</div>
                                          </Col>
                                        </Row>
                                        <Row className="mt-2">
                                          <Col md={12}>
                                            <small className="text-muted">
                                              Endereco
                                              {renderCheckReprovacao(
                                                'Herdeiro',
                                                'Endereco',
                                                'Endereço completo',
                                                herdeiro.codigo
                                              )}
                                            </small>
                                            <div>
                                              {[
                                                herdeiro.logradouro,
                                                herdeiro.numero,
                                                herdeiro.complemento,
                                                herdeiro.bairro,
                                                herdeiro.cidade &&
                                                herdeiro.estado
                                                  ? `${herdeiro.cidade}/${herdeiro.estado}`
                                                  : herdeiro.cidade ||
                                                    herdeiro.estado,
                                                herdeiro.cep
                                                  ? `CEP ${herdeiro.cep}`
                                                  : '',
                                              ]
                                                .filter(Boolean)
                                                .join(', ') || '-'}
                                            </div>
                                          </Col>
                                        </Row>
                                        {herdeiro.anexos &&
                                          herdeiro.anexos.length > 0 && (
                                            <Row className="mt-3">
                                              <Col md={12}>
                                                <small className="text-muted d-block mb-1">
                                                  Anexos
                                                </small>
                                                {herdeiro.anexos.map(anexo => (
                                                  <div
                                                    key={anexo.codigo}
                                                    className="d-inline-flex align-items-center mr-3 mb-1"
                                                  >
                                                    <Button
                                                      variant="outline-info"
                                                      size="sm"
                                                      onClick={() => {
                                                        if (!anexo.codigo) {
                                                          toast.error(
                                                            'Anexo sem codigo. Recarregue a tela.'
                                                          );
                                                          return;
                                                        }
                                                        api
                                                          .obterAnexoHerdeiroEscritura(
                                                            anexo.codigo
                                                          )
                                                          .then(blob => {
                                                            // httpService.get ja retorna res.data direto
                                                            if (
                                                              !blob ||
                                                              blob.size === 0
                                                            ) {
                                                              toast.error(
                                                                'Arquivo vazio retornado pelo servidor.'
                                                              );
                                                              return;
                                                            }
                                                            const tipo =
                                                              blob.type ||
                                                              'application/pdf';
                                                            const url = window.URL.createObjectURL(
                                                              new Blob([blob], {
                                                                type: tipo,
                                                              })
                                                            );
                                                            window.open(
                                                              url,
                                                              '_blank'
                                                            );
                                                          })
                                                          .catch(err => {
                                                            const msg =
                                                              err &&
                                                              err.response &&
                                                              err.response
                                                                .status
                                                                ? `Erro ${err.response.status} ao abrir anexo`
                                                                : 'Erro ao abrir anexo.';
                                                            toast.error(msg);
                                                          });
                                                      }}
                                                    >
                                                      <FaEye className="mr-1" />
                                                      {anexo.tipo_anexo_descricao ||
                                                        anexo.nome_arquivo}
                                                    </Button>
                                                    {renderCheckReprovacao(
                                                      'AnexoHerdeiro',
                                                      `Anexo_${anexo.tipo_anexo}`,
                                                      anexo.tipo_anexo_descricao ||
                                                        'Anexo',
                                                      herdeiro.codigo
                                                    )}
                                                  </div>
                                                ))}
                                              </Col>
                                            </Row>
                                          )}
                                      </div>
                                    )
                                  )}
                                </Card.Body>
                              </div>
                            </Collapse>
                          </Card>
                        )}
                    </>
                  )}

                  {itemSelecionado.etapa_atual === 2 &&
                    itemSelecionado.status_etapa === 2 &&
                    detalhesCliente &&
                    detalhesCliente.herdeiros &&
                    detalhesCliente.herdeiros.length > 0 && (
                      <div className="text-center mt-4 mb-2">
                        <span
                          className="badge badge-pill px-4 py-2"
                          style={{
                            backgroundColor: '#28a745',
                            color: '#fff',
                            fontSize: '1rem',
                          }}
                        >
                          <FaCheck className="mr-2" />
                          Finalizado
                        </span>
                        <p
                          className="text-muted mt-2 mb-0"
                          style={{ fontSize: '0.85em' }}
                        >
                          Documentação aprovada. O cliente deverá realizar nova
                          solicitação em nome do(s) herdeiro(s).
                        </p>
                      </div>
                    )}

                  {/* Seção de Aprovação/Reprovação - Apenas para Etapa 2 (Análise da Documentação) */}
                  {itemSelecionado.etapa_atual === 2 &&
                    itemSelecionado.status_etapa !== 2 && (
                      <>
                        <hr className="mt-4" />
                        <div className="mt-3">
                          {!acaoSelecionada ? (
                            <div className="d-flex flex-column align-items-center">
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="outline-danger"
                                  className="mr-3"
                                  onClick={() =>
                                    handleSelecionarAcao('reprovar')
                                  }
                                >
                                  <FaTimes className="mr-2" />
                                  Reprovar
                                </Button>
                                <Button
                                  variant="outline-success"
                                  onClick={() =>
                                    handleSelecionarAcao('aprovar')
                                  }
                                  disabled={camposReprovados.length > 0}
                                  title={
                                    camposReprovados.length > 0
                                      ? 'Existem campos marcados como reprovados — desmarque todos para aprovar a solicitacao inteira'
                                      : ''
                                  }
                                >
                                  <FaCheck className="mr-2" />
                                  Aprovar
                                </Button>
                              </div>
                              {camposReprovados.length > 0 && (
                                <small className="text-muted mt-2">
                                  <FaInfoCircle className="mr-1" />
                                  {camposReprovados.length} campo(s) marcado(s)
                                  como reprovado(s). Desmarque todos para
                                  habilitar a aprovacao.
                                </small>
                              )}
                            </div>
                          ) : (
                            <div>
                              <div className="mb-3">
                                <span
                                  className={`badge ${
                                    acaoSelecionada === 'aprovar'
                                      ? 'badge-success'
                                      : 'badge-danger'
                                  } p-2`}
                                >
                                  {acaoSelecionada === 'aprovar'
                                    ? 'Aprovando solicitação'
                                    : 'Reprovando solicitação'}
                                </span>
                              </div>
                              {acaoSelecionada === 'reprovar' &&
                                isFluxoHerdeiros && (
                                  <div className="alert alert-warning py-2 mb-3">
                                    <small>
                                      <strong>
                                        Fluxo de Herdeiros / Espólios:
                                      </strong>{' '}
                                      role até a seção "Herdeiros / Espólios" e
                                      marque o botão{' '}
                                      <span className="text-danger">
                                        Reprovar
                                      </span>{' '}
                                      ao lado de cada campo / anexo que precisa
                                      de correção. Marcados:{' '}
                                      <strong>{camposReprovados.length}</strong>
                                    </small>
                                  </div>
                                )}
                              <Form.Group>
                                <Form.Label>
                                  Observação
                                  {acaoSelecionada === 'reprovar' && (
                                    <span className="text-danger"> *</span>
                                  )}
                                </Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={3}
                                  placeholder={
                                    acaoSelecionada === 'reprovar'
                                      ? 'Descreva o motivo da reprovação...'
                                      : 'Digite uma observação...'
                                  }
                                  value={observacaoAcao}
                                  onChange={e =>
                                    setObservacaoAcao(e.target.value)
                                  }
                                />
                              </Form.Group>
                              <Form.Group className="mt-3">
                                <Form.Check
                                  type="checkbox"
                                  id="enviar-email-cliente"
                                  label="Enviar email ao cliente com a atualização"
                                  checked={enviarEmailCliente}
                                  onChange={e =>
                                    setEnviarEmailCliente(e.target.checked)
                                  }
                                />
                              </Form.Group>
                              <div className="d-flex justify-content-end mt-3">
                                <Button
                                  variant="outline-secondary"
                                  className="mr-2"
                                  onClick={handleCancelarAcao}
                                  disabled={isLoadingAcao}
                                >
                                  Cancelar
                                </Button>
                                <Button
                                  variant={
                                    acaoSelecionada === 'aprovar'
                                      ? 'success'
                                      : 'danger'
                                  }
                                  onClick={handleConfirmarAcao}
                                  disabled={isLoadingAcao}
                                >
                                  {isLoadingAcao ? (
                                    <>
                                      <Spinner
                                        animation="border"
                                        size="sm"
                                        className="mr-2"
                                      />
                                      Processando...
                                    </>
                                  ) : acaoSelecionada === 'aprovar' ? (
                                    <>
                                      <FaCheck className="mr-2" />
                                      Confirmar Aprovação
                                    </>
                                  ) : (
                                    <>
                                      <FaTimes className="mr-2" />
                                      Confirmar Reprovação
                                    </>
                                  )}
                                </Button>
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                </div>
              </Tab>
              <Tab
                eventKey="historico"
                title={
                  <span>
                    <FaHistory className="mr-1" />
                    Histórico
                    {itemSelecionado.historico &&
                      itemSelecionado.historico.length > 0 && (
                        <Badge
                          variant="light"
                          className="ml-1"
                          style={{ fontSize: '0.7em', color: '#6c757d' }}
                        >
                          {itemSelecionado.historico.length}
                        </Badge>
                      )}
                  </span>
                }
              >
                <div className="pt-3">
                  {itemSelecionado.historico &&
                  itemSelecionado.historico.length > 0 ? (
                    <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                      <BsTable
                        bordered
                        hover
                        size="sm"
                        style={{ fontSize: '0.8em', marginBottom: 0 }}
                      >
                        <thead style={{ backgroundColor: '#f8f9fa' }}>
                          <tr>
                            <th style={{ width: '100px', padding: '6px 8px' }}>
                              Data
                            </th>
                            <th style={{ padding: '6px 8px' }}>Etapa</th>
                            <th style={{ padding: '6px 8px' }}>Status</th>
                            <th style={{ padding: '6px 8px' }}>Responsável</th>
                            <th style={{ padding: '6px 8px' }}>Observação</th>
                          </tr>
                        </thead>
                        <tbody>
                          {itemSelecionado.historico.map((hist, idx) => (
                            <tr key={hist.codigo || idx}>
                              <td
                                style={{
                                  padding: '6px 8px',
                                  verticalAlign: 'middle',
                                }}
                              >
                                <div style={{ fontSize: '0.9em' }}>
                                  {format.date(hist.data)}
                                </div>
                                <div
                                  style={{
                                    fontSize: '0.8em',
                                    color: '#6c757d',
                                  }}
                                >
                                  {format.datetime(hist.data, 'HH:mm')}
                                </div>
                              </td>
                              <td
                                style={{
                                  padding: '6px 8px',
                                  verticalAlign: 'middle',
                                  fontSize: '0.9em',
                                }}
                              >
                                {getDescricaoEtapa(hist.etapa)}
                              </td>
                              <td
                                style={{
                                  padding: '6px 8px',
                                  verticalAlign: 'middle',
                                  fontSize: '0.9em',
                                }}
                              >
                                {getDescricaoStatus(hist.status_etapa)}
                              </td>
                              <td
                                style={{
                                  padding: '6px 8px',
                                  verticalAlign: 'middle',
                                  fontSize: '0.9em',
                                }}
                              >
                                {hist.especialista_responsavel || 'Cliente'}
                              </td>
                              <td
                                style={{
                                  padding: '6px 8px',
                                  verticalAlign: 'middle',
                                  fontSize: '0.85em',
                                  color: '#6c757d',
                                  textAlign: 'left',
                                }}
                              >
                                {hist.observacao || '-'}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </BsTable>
                    </div>
                  ) : (
                    <div className="text-center py-4">
                      <FaHistory color="#dee2e6" size={40} />
                      <p
                        className="mt-2 mb-0 text-muted"
                        style={{ fontSize: '0.9em' }}
                      >
                        Nenhum registro de histórico
                      </p>
                    </div>
                  )}
                </div>
              </Tab>
              {itemSelecionado.etapa_atual === 4 && (
                <Tab
                  eventKey="documentos"
                  title={
                    <span>
                      <FaFilePdf className="mr-1" />
                      Documentos
                    </span>
                  }
                >
                  <div className="pt-3">
                    <DisplayDocumentosEscritura
                      codigoBoleto={itemSelecionado.codigo_boleto}
                      abas={[
                        {
                          key: 'autorizacao',
                          label: 'Autorização de Escritura',
                        },
                        {
                          key: 'escritura',
                          label: 'Documento Disponibilizado',
                        },
                      ]}
                    />
                  </div>
                </Tab>
              )}
            </Tabs>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={handleCloseModalDetalhes}
          >
            <FaWindowClose className="mr-1" />
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showModalEnviarDoc}
        onHide={handleCloseModalEnviarDoc}
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaFileUpload color="#28a745" style={{ marginRight: '8px' }} />
            Enviar Documento de Escritura
            {itemEnviarDoc && (
              <span className="text-muted ml-2" style={{ fontSize: '0.7em' }}>
                (Solicitação Nº {itemEnviarDoc.codigo})
              </span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {itemEnviarDoc && (
            <>
              <Card className="mb-3 border-info">
                <Card.Body className="py-2">
                  <Row>
                    <Col md={4}>
                      <small className="text-muted">Solicitante</small>
                      <div>
                        <strong>{itemEnviarDoc.solicitante}</strong>
                      </div>
                    </Col>
                    <Col md={4}>
                      <small className="text-muted">Empreendimento</small>
                      <div>
                        <strong>{itemEnviarDoc.empreendimento}</strong>
                      </div>
                    </Col>
                    <Col md={4}>
                      <small className="text-muted">Quadra/Lote</small>
                      <div>
                        <strong>
                          {itemEnviarDoc.quadra}/{itemEnviarDoc.lote}
                        </strong>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {itemEnviarDoc.codigo_documento_digital && (
                <Alert variant="warning" className="d-flex align-items-start">
                  <FaInfoCircle className="mr-2 mt-1 flex-shrink-0" />
                  <div>
                    <strong>Atenção:</strong> Esta solicitação possui um
                    processo de documento digital em andamento. Considere
                    aguardar a finalização do fluxo de assinatura digital antes
                    de enviar o documento manualmente.
                  </div>
                </Alert>
              )}

              <Form.Group className="mb-3">
                <Form.Label>
                  <strong>Documento (PDF)</strong>
                </Form.Label>
                <div
                  className="border rounded p-3"
                  style={{ backgroundColor: '#f8f9fa' }}
                >
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    accept=".pdf"
                    onChange={handleFileSelect}
                  />

                  {!arquivoSelecionado ? (
                    <div className="text-center py-4">
                      <FaFilePdf size={48} color="#dc3545" className="mb-3" />
                      <p className="text-muted mb-3">
                        Selecione um arquivo PDF para enviar
                      </p>
                      <Button
                        variant="outline-primary"
                        onClick={() =>
                          fileInputRef.current && fileInputRef.current.click()
                        }
                      >
                        <FaFileUpload className="mr-2" />
                        Selecionar Arquivo
                      </Button>
                      <p
                        className="text-muted mt-2 mb-0"
                        style={{ fontSize: '0.8em' }}
                      >
                        Tamanho máximo: 10MB
                      </p>
                    </div>
                  ) : (
                    <div>
                      <div className="d-flex align-items-center justify-content-between p-2 bg-white rounded border">
                        <div className="d-flex align-items-center">
                          <FaFilePdf
                            size={32}
                            color="#dc3545"
                            className="mr-3"
                          />
                          <div>
                            <strong>{arquivoSelecionado.name}</strong>
                            <br />
                            <small className="text-muted">
                              {(arquivoSelecionado.size / 1024 / 1024).toFixed(
                                2
                              )}{' '}
                              MB
                            </small>
                          </div>
                        </div>
                        <div>
                          {arquivoPreview && (
                            <Button
                              variant="outline-info"
                              size="sm"
                              className="mr-2"
                              onClick={() =>
                                window.open(arquivoPreview, '_blank')
                              }
                              title="Visualizar"
                            >
                              <FaEye />
                            </Button>
                          )}
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={handleRemoverArquivo}
                            title="Remover"
                          >
                            <FaTrash />
                          </Button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Form.Group>

              {/* Observação */}
              <Form.Group className="mb-3">
                <Form.Label>Observação</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  placeholder="Observação sobre o envio do documento..."
                  value={observacaoDocumento}
                  onChange={e => setObservacaoDocumento(e.target.value)}
                />
              </Form.Group>

              {/* Checkbox Enviar Email */}
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  id="enviar-email-documento"
                  label="Enviar email ao cliente notificando o envio do documento"
                  checked={enviarEmailDocumento}
                  onChange={e => setEnviarEmailDocumento(e.target.checked)}
                />
              </Form.Group>

              {/* Área de Mensagem do Email (condicional) */}
              {enviarEmailDocumento && (
                <Form.Group className="mb-3">
                  <Form.Label>Mensagem do Email</Form.Label>
                  <ReactQuill
                    value={mensagemEmailDocumento}
                    onChange={value => setMensagemEmailDocumento(value)}
                    theme="snow"
                    placeholder="Digite a mensagem que será enviada ao cliente por email..."
                    style={{ backgroundColor: '#fff' }}
                  />
                  <Form.Text className="text-muted">
                    Esta mensagem será incluída no corpo do email enviado ao
                    cliente.
                  </Form.Text>
                </Form.Group>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={handleCloseModalEnviarDoc}
            disabled={isLoadingEnviarDoc}
          >
            <FaWindowClose className="mr-1" />
            Cancelar
          </Button>
          <Button
            variant="success"
            onClick={handleConfirmarEnvioDocumento}
            disabled={isLoadingEnviarDoc || !arquivoSelecionado}
          >
            {isLoadingEnviarDoc ? (
              <>
                <Spinner animation="border" size="sm" className="mr-2" />
                Enviando...
              </>
            ) : (
              <>
                <FaPaperPlane className="mr-2" />
                Enviar Documento
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Confirmação Envio com Email */}
      <Modal
        show={showModalConfirmacaoEnvio}
        onHide={() => setShowModalConfirmacaoEnvio(false)}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaEnvelope color="#17a2b8" style={{ marginRight: '8px' }} />
            Confirmar Envio
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            O texto e documento anexado serão enviados ao cliente via e-mail e a
            solicitação será finalizada.
          </p>
          <p className="mb-0">
            Este arquivo também ficará disponível ao cliente para download.
          </p>
          <p className="mt-3 mb-0 font-weight-bold">Confirmar envio?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() => setShowModalConfirmacaoEnvio(false)}
            disabled={isLoadingEnviarDoc}
          >
            Cancelar
          </Button>
          <Button
            variant="success"
            onClick={executarEnvioDocumento}
            disabled={isLoadingEnviarDoc}
          >
            {isLoadingEnviarDoc ? (
              <>
                <Spinner animation="border" size="sm" className="mr-2" />
                Enviando...
              </>
            ) : (
              <>
                <FaCheck className="mr-2" />
                Confirmar
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Gerenciar Status */}
      <Modal
        show={showModalGerenciarStatus}
        onHide={handleCloseModalGerenciarStatus}
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaCog color="#0d6efd" style={{ marginRight: '8px' }} />
            Gerenciar Status
            {itemGerenciarStatus && (
              <span className="text-muted ml-2" style={{ fontSize: '0.7em' }}>
                (Solicitação Nº {itemGerenciarStatus.codigo})
              </span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {itemGerenciarStatus && (
            <>
              <div className="alert alert-info d-flex align-items-start mb-3">
                <FaInfoCircle className="mr-2 mt-1" size={18} />
                <div>
                  <strong>Status atual:</strong> Etapa{' '}
                  {itemGerenciarStatus.etapa_atual} -{' '}
                  {getDescricaoEtapa(itemGerenciarStatus.etapa_atual)} (
                  {getDescricaoStatus(itemGerenciarStatus.status_etapa)})
                </div>
              </div>

              <Form.Group className="mb-3">
                <Form.Label>
                  <strong>Nova Etapa</strong>
                </Form.Label>
                <Select
                  placeholder="Selecione a etapa..."
                  options={ETAPAS_OPTIONS}
                  value={etapaSelecionadaStatus}
                  onChange={option => {
                    setEtapaSelecionadaStatus(option);
                    setSubStatusSelecionado(null);
                    if (option && option.value !== 4) {
                      setArquivoGerenciarStatus(null);
                      if (arquivoGerenciarStatusPreview) {
                        URL.revokeObjectURL(arquivoGerenciarStatusPreview);
                      }
                      setArquivoGerenciarStatusPreview(null);
                      if (fileInputGerenciarStatusRef.current) {
                        fileInputGerenciarStatusRef.current.value = '';
                      }
                    }
                  }}
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                />
              </Form.Group>

              {etapaSelecionadaStatus && etapaSelecionadaStatus.value === 2 && (
                <Form.Group className="mb-3">
                  <Form.Label>
                    <strong>Resultado da Análise</strong>
                  </Form.Label>
                  <div className="d-flex">
                    <Button
                      variant={
                        subStatusSelecionado === 'aprovar'
                          ? 'success'
                          : 'outline-success'
                      }
                      className="mr-2 flex-fill"
                      onClick={() => setSubStatusSelecionado('aprovar')}
                    >
                      <FaCheck className="mr-2" />
                      Aprovar
                    </Button>
                    <Button
                      variant={
                        subStatusSelecionado === 'reprovar'
                          ? 'danger'
                          : 'outline-danger'
                      }
                      className="flex-fill"
                      onClick={() => setSubStatusSelecionado('reprovar')}
                    >
                      <FaTimes className="mr-2" />
                      Reprovar
                    </Button>
                  </div>
                  {subStatusSelecionado && (
                    <Form.Text
                      className={
                        subStatusSelecionado === 'aprovar'
                          ? 'text-success'
                          : 'text-danger'
                      }
                    >
                      {subStatusSelecionado === 'aprovar'
                        ? 'A solicitação será aprovada e avançará para a próxima etapa.'
                        : 'A solicitação será reprovada e voltará para correção.'}
                    </Form.Text>
                  )}
                </Form.Group>
              )}

              {etapaSelecionadaStatus && etapaSelecionadaStatus.value === 4 && (
                <Form.Group className="mb-3">
                  <Form.Label>
                    <strong>Anexar Documento (PDF)</strong>
                  </Form.Label>
                  <div
                    className="border rounded p-3"
                    style={{ backgroundColor: '#f8f9fa' }}
                  >
                    <input
                      type="file"
                      ref={fileInputGerenciarStatusRef}
                      style={{ display: 'none' }}
                      accept=".pdf"
                      onChange={handleFileGerenciarStatusSelect}
                    />

                    {!arquivoGerenciarStatus ? (
                      <div className="text-center py-3">
                        <FaFilePdf size={40} color="#dc3545" className="mb-2" />
                        <p
                          className="text-muted mb-2"
                          style={{ fontSize: '0.9em' }}
                        >
                          Clique para selecionar um arquivo PDF
                        </p>
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={() =>
                            fileInputGerenciarStatusRef.current &&
                            fileInputGerenciarStatusRef.current.click()
                          }
                        >
                          <FaFileUpload className="mr-2" />
                          Selecionar Arquivo
                        </Button>
                        <p
                          className="text-muted mt-2 mb-0"
                          style={{ fontSize: '0.75em' }}
                        >
                          Tamanho máximo: 10MB
                        </p>
                      </div>
                    ) : (
                      <div className="d-flex align-items-center justify-content-between p-2 bg-white rounded border">
                        <div className="d-flex align-items-center">
                          <FaFilePdf
                            size={28}
                            color="#dc3545"
                            className="mr-3"
                          />
                          <div>
                            <strong style={{ fontSize: '0.9em' }}>
                              {arquivoGerenciarStatus.name}
                            </strong>
                            <br />
                            <small className="text-muted">
                              {(
                                arquivoGerenciarStatus.size /
                                1024 /
                                1024
                              ).toFixed(2)}{' '}
                              MB
                            </small>
                          </div>
                        </div>
                        <div>
                          {arquivoGerenciarStatusPreview && (
                            <Button
                              variant="outline-info"
                              size="sm"
                              className="mr-2"
                              onClick={() =>
                                window.open(
                                  arquivoGerenciarStatusPreview,
                                  '_blank'
                                )
                              }
                              title="Visualizar"
                            >
                              <FaEye />
                            </Button>
                          )}
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={handleRemoverArquivoGerenciarStatus}
                            title="Remover"
                          >
                            <FaTrash />
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                </Form.Group>
              )}

              <Form.Group className="mb-3">
                <Form.Label>
                  <strong>Observação</strong>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Digite uma observação sobre a alteração de status..."
                  value={observacaoGerenciarStatus}
                  onChange={e => setObservacaoGerenciarStatus(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  id="enviar-email-gerenciar-status"
                  label="Enviar e-mail ao cliente com a atualização"
                  checked={enviarEmailGerenciarStatus}
                  onChange={e =>
                    setEnviarEmailGerenciarStatus(e.target.checked)
                  }
                />
              </Form.Group>

              {enviarEmailGerenciarStatus &&
                etapaSelecionadaStatus &&
                etapaSelecionadaStatus.value === 4 && (
                  <Form.Group className="mb-0">
                    <Form.Label>Mensagem do Email</Form.Label>
                    <ReactQuill
                      value={mensagemEmailGerenciarStatus}
                      onChange={value => setMensagemEmailGerenciarStatus(value)}
                      theme="snow"
                      placeholder="Digite a mensagem que será enviada ao cliente por email..."
                      style={{ backgroundColor: '#fff' }}
                    />
                    <Form.Text className="text-muted">
                      Esta mensagem será incluída no corpo do email enviado ao
                      cliente.
                    </Form.Text>
                  </Form.Group>
                )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={handleCloseModalGerenciarStatus}
            disabled={isLoadingGerenciarStatus}
          >
            <FaWindowClose className="mr-1" />
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirmarGerenciarStatus}
            disabled={isLoadingGerenciarStatus || !etapaSelecionadaStatus}
          >
            {isLoadingGerenciarStatus ? (
              <>
                <Spinner animation="border" size="sm" className="mr-2" />
                Salvando...
              </>
            ) : (
              <>
                <FaCheck className="mr-2" />
                Confirmar
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showModalAvisoSemDocumento}
        onHide={() => setShowModalAvisoSemDocumento(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaInfoCircle color="#fd7e14" style={{ marginRight: '8px' }} />
            Atenção
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Não será disponibilizado nenhum documento na área do cliente. Deseja
            prosseguir mesmo assim?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() => setShowModalAvisoSemDocumento(false)}
          >
            Cancelar
          </Button>
          <Button variant="warning" onClick={executarGerenciarStatus}>
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showModalDocDigital}
        onHide={() => {
          setShowModalDocDigital(false);
          setItemDocDigital(null);
        }}
        size="xl"
        backdrop="static"
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaFileSignature style={{ marginRight: '8px' }} />
            Documento Digital - Escritura
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {itemDocDigital && (
            <DocumentoDigitalEscritura
              codigoDocumentoDigital={itemDocDigital.codigo_documento_digital}
              codigoBoleto={itemDocDigital.codigo_boleto}
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
